import React, { Component } from "react";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Nav";
import "../styles/userInfo.css";
import Tabs from "../components/Tabs";
import LoadingPage from "../components/LoadingPage";

//redux
import { connect } from "react-redux";

//Material UI
import withStyles from "@material-ui/core/styles/withStyles";
//font awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faEnvelope, faCar } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookSquare,
  faInstagramSquare,
  faLinkedin
} from "@fortawesome/free-brands-svg-icons";

const styles = {
  container: {
    width: "fit-content",
    margin: "auto"
  },
  userInfoDiv: {
    width: "fit-content",
    margin: "auto",
    marginTop: "20px"
  }
};

class userInfo extends Component {
  togglePills = (type, tab) => e => {
    e.preventDefault();
    if (this.state.items[type] !== tab) {
      let items = { ...this.state.items };
      items[type] = tab;
      this.setState({
        items
      });
    }
  };

  state = {
    loggedUserInfo: {},
    items: {
      default: "1"
    },
    loading: true
  };

  componentDidMount() {
    axios
      .get("https://us-central1-ipark-app-3143c.cloudfunctions.net/api/user")
      .then(response =>
        this.setState({ loggedUserInfo: response.data, loading: false })
      );
  }

  handleChange = e => {
    this.setState({
      loggedUserInfo: {
        ...this.state.loggedUserInfo,
        [e.target.name]: e.target.value
      }
    });
  };

  saveButtonHandler = async () => {
    const { loggedUserInfo } = this.state;
    this.setState({ loading: true });
    try {
      await axios
        .post(
          "https://us-central1-ipark-app-3143c.cloudfunctions.net/api/user/edit",
          loggedUserInfo
        )
        .then(res => {
          alert(res.data.message);
        })
        .catch(err => console.log(err));
    } catch (err) {
      console.log(err);
    }

    this.setState({ loading: false });
  };

  cancelButtonHandler = () => {
    this.setState({ isEditButtonClicked: false });
  };

  render() {
    const { loggedUserInfo } = this.state;
    const { user } = this.props;
    const divClassname =
      this.props.user.role === "admin"
        ? "col-md-8 col-lg-10 p-0 mt-5"
        : "col-md-8 col-lg-12 p-0 mt-5";

    return (
      <div>
        <Navbar />
        {this.state.loading ? (
          <LoadingPage />
        ) : (
          <div className="row">
            {user.role === "admin" && (
              <div class="col-md-2 d-md-block sidebar">
                <Sidebar />
              </div>
            )}
            <div className={divClassname}>
              <div className="container">
                <div className="row user-info-row">
                  <div className="col-lg-4">
                    <div className="profile-card-4 z-depth-3">
                      <div className="card">
                        <div className="card-body text-center bg-light rounded-top">
                          <div className="user-box">
                            <FontAwesomeIcon
                              className="faUserIcon"
                              icon={faUser}
                            />
                            <h5>{`${loggedUserInfo.firstName} ${loggedUserInfo.lastName}`}</h5>
                            <h6>{user.role}</h6>
                          </div>
                        </div>
                        <div className="card-body">
                          <ul className="list-group shadow-none">
                            <li className="list-group-item">
                              <div className="list-icon">
                                <FontAwesomeIcon icon={faEnvelope} />
                              </div>
                              <div className="list-details">
                                <span>{loggedUserInfo.email}</span>
                                <small className="email-small">Email</small>
                              </div>
                            </li>
                            <li className="list-group-item">
                              <div className="list-icon">
                                <FontAwesomeIcon icon={faCar} />
                              </div>
                              <div className="list-details">
                                <span>{loggedUserInfo.plateNumber}</span>
                                <small>Plate Number</small>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="card-footer text-center">
                          <FontAwesomeIcon icon={faFacebookSquare} />
                          <FontAwesomeIcon icon={faInstagramSquare} />
                          <FontAwesomeIcon icon={faLinkedin} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <div className="card z-depth-3">
                      <div className="card-body">
                        <Tabs>
                          <div label="PROFILE">
                            <div id="profile">
                              <h5>User Profile</h5>
                            </div>
                            <div>
                              <p className="info">
                                Name:{" "}
                                <span className="name userInfo">
                                  {loggedUserInfo.firstName}{" "}
                                </span>
                                <span className="userInfo">
                                  {loggedUserInfo.lastName}
                                </span>
                              </p>
                              <p className="info">
                                Username:{" "}
                                <span className="username userInfo">
                                  {loggedUserInfo.username}
                                </span>
                              </p>
                              <p className="info">
                                Email:{" "}
                                <span className="email userInfo">
                                  {loggedUserInfo.email}
                                </span>
                              </p>
                              <p className="info">
                                Plate Number:{" "}
                                <span className="plateNumber userInfo">
                                  {loggedUserInfo.plateNumber}
                                </span>
                              </p>
                            </div>
                          </div>
                          <div label="EDIT">
                            <form>
                              <div className="form-group row">
                                <label className="col-lg-3 col-form-label form-control-label">
                                  First Name
                                </label>
                                <div className="col-lg-9">
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={loggedUserInfo.firstName}
                                    name="firstName"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                              <div className="form-group row">
                                <label className="col-lg-3 col-form-label form-control-label">
                                  Last Name
                                </label>
                                <div className="col-lg-9">
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={loggedUserInfo.lastName}
                                    name="lastName"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                              <div className="form-group row">
                                <label className="col-lg-3 col-form-label form-control-label">
                                  Email
                                </label>
                                <div className="col-lg-9">
                                  <label className="form-control-label p-1 text-secondary font-italic">
                                    {loggedUserInfo.email}
                                  </label>
                                </div>
                              </div>
                              <div className="form-group row">
                                <label className="col-lg-3 col-form-label form-control-label">
                                  username
                                </label>
                                <div className="col-lg-9">
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={loggedUserInfo.username}
                                    name="username"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                              <div className="form-group row">
                                <label className="col-lg-3 col-form-label form-control-label">
                                  Plate Number
                                </label>
                                <div className="col-lg-9">
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={loggedUserInfo.plateNumber}
                                    name="plateNumber"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                              <div className="button-div">
                                <button
                                  type="button"
                                  class="btn btn-primary profile-info-edit"
                                  onClick={this.saveButtonHandler}
                                >
                                  Save Changes
                                </button>
                              </div>
                            </form>
                          </div>
                        </Tabs>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(withStyles(styles)(userInfo));
